import React from "react";
// Correctly import the video file
import videoSrc from '../Assest/perfume1.mp4';

const Video = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background video */}
      <video
        src={videoSrc}
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
  
      {/* Content over the video */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white px-4 sm:px-8">
        <h1 className="text-4xl sm:text-5xl font-extrabold drop-shadow-lg">
          Explore the Essence of Luxury
        </h1>
        <p className="text-lg sm:text-xl mt-4">
          Discover the captivating world of luxury perfumes. Indulge your senses in the finest fragrances.
        </p>
      </div>
    </div>
  );
};

export default Video;
